import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useAuth } from './AuthContext';

// Where "go back" should land for whoever is looking at the 404. Borrowers and
// realtors have their own portals (PortalLayout bounces them there anyway).
export const homeFor = (user) => {
  if (!user) return { to: '/portal/login', label: 'Go to sign in' };
  if (user.role === 'borrower') return { to: '/borrower', label: 'Back to your portal' };
  if (user.role === 'realtor') return { to: '/realtor', label: 'Back to your portal' };
  if (user.role === 'party') return { to: '/party', label: 'Back to your deals' };
  return { to: '/portal', label: 'Back to dashboard' };
};

function NotFoundMessage({ to, label }) {
  return (
    <div className="p-10 max-w-lg mx-auto text-center" data-testid="not-found">
      <Compass size={40} className="mx-auto text-slate-300 mb-3" />
      <div className="font-serif text-xl font-bold" style={{ color: '#070B5F' }}>Page not found</div>
      <div className="text-sm text-slate-500 mt-2">
        This link doesn't go anywhere. It may be mistyped, or the page may have moved.
      </div>
      <Link to={to} className="inline-block mt-4 text-sm font-medium" style={{ color: '#6BA82E' }}>
        {label}
      </Link>
    </div>
  );
}

// Unknown URL under /portal. Rendered inside PortalLayout, so auth is already
// resolved and the nav stays visible.
export function PortalNotFound() {
  return <NotFoundMessage to="/portal" label="Back to dashboard" />;
}

// Unknown URL anywhere else. Without this catch-all, react-router rendered
// nothing and users saw a blank page.
export default function NotFoundPage() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#f8fafc' }}>
        <div className="w-12 h-12 border-4 border-slate-200 border-t-[#6BA82E] rounded-full animate-spin" />
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#f8fafc' }}>
      <NotFoundMessage {...homeFor(user)} />
    </div>
  );
}
